
import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import T from '../lang';

@Component
export default class RadioSwitch extends Vue {
  @Prop() name!: string;
  @Prop({ default: false }) readonly!: boolean;
  @Prop() selectedValue!: any;
  @Prop({ default: true }) valueForTrue!: any;
  @Prop({ default: false }) valueForFalse!: any;
  @Prop({ default: T.wordsYes }) textForTrue!: string;
  @Prop({ default: T.wordsNo }) textForFalse!: string;

  radioValue = this.selectedValue ?? this.valueForFalse;

  @Watch('radioValue')
  @Emit('update:value')
  onUpdateInput(newValue: any): any {
    return newValue;
  }
}
